import React from "react";

const Footer = () => (
  <div className="footer">
    <p className="footer-text">by <a href="https://twitter.com/NikitBhandari" target="_blank" rel="noopener noreferrer"><b>@NikitBhandari</b></a>  </p>
  </div>
);

export default Footer;